import React from "react";
import { useTranslation } from "react-i18next"; // Import useTranslation
// Import the necessary types from productApiTypes
import type {
  TransformedProduct,
  TransformedCategory,
} from "../../types/productApiTypes";

// Props only require the main product object now
interface ProductBreadcrumbsProps {
  product: TransformedProduct;
}

const ProductBreadcrumbs: React.FC<ProductBreadcrumbsProps> = ({ product }) => {
  const { t } = useTranslation(); // Initialize useTranslation

  // Extract enriched categories directly from the product prop
  // Provide a fallback empty array if enrichedCategories is missing or null
  const productCategories: TransformedCategory[] =
    product.enrichedCategories || [];

  // Determine the primary category (first one in the array)
  const primaryCategory =
    productCategories.length > 0 ? productCategories[0] : undefined;

  // Get base URLs from theme variables or provide fallbacks
  const siteUrl = window.themeVariables?.siteUrl || "/"; // Fallback to root
  const shopUrl = `${siteUrl}/shop/`; // Assuming '/shop/' is the shop slug

  return (
    <nav aria-label="Breadcrumb" className="product-breadcrumbs">
      {/* Link to Home */}
      <a href={siteUrl}>{t("breadcrumbs.home")}</a> / {/* Translate Home */}
      {/* Link to Shop */}
      <a href={shopUrl}>{t("breadcrumbs.shop")}</a> / {/* Translate Shop */}
      {/* Link to Primary Category (if exists) */}
      {primaryCategory && (
        <>
          {/* Link to shop page filtered by this category's ID */}
          <a href={`${shopUrl}?category=${primaryCategory.id}`}>
            {primaryCategory.name}
          </a>{" "}
          /
        </>
      )}
      {/* Current Product Name (not a link) */}
      <span>{product.name}</span>
    </nav>
  );
};

export default ProductBreadcrumbs;
